<template>
    <div class="app-drawer-modal" role="dialog" aria-modal="true">
        <button
            type="button"
            class="app-drawer-modal__backdrop"
            :aria-label="$t('close')"
            @click="closeModal"
        />

        <div class="app-drawer-modal__panel">
            <div v-if="$slots.header" class="app-drawer-modal__header">
                <slot name="header"></slot>
            </div>

            <div v-if="$slots.body" class="app-drawer-modal__body" :class="bodyClass">
                <slot name="body"></slot>
            </div>

            <div v-if="$slots.footer" class="app-drawer-modal__footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DrawerModal',
    props: {
        bodyClass: {
            type: String,
            default: '',
        },
    },
    mounted() {
        this.previousHtmlOverflow = document.documentElement.style.overflow;
        this.previousBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleEscape);
    },
    beforeDestroy() {
        document.documentElement.style.overflow = this.previousHtmlOverflow || '';
        document.body.style.overflow = this.previousBodyOverflow || '';
        document.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        handleEscape(event) {
            if (event.key === 'Escape') {
                this.closeModal();
            }
        },
    },
}
</script>

<style scoped>
.app-drawer-modal {
    position: fixed;
    inset: 0;
    z-index: 1060;
}

.app-drawer-modal__backdrop {
    position: absolute;
    inset: 0;
    border: 0;
    background: rgba(15, 23, 42, 0.42);
    cursor: default;
}

.app-drawer-modal__panel {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    width: min(560px, 100%);
    max-width: 100%;
    height: 100%;
    background: #fff;
    box-shadow: -24px 0 48px rgba(15, 23, 42, 0.18);
    animation: app-drawer-modal-slide-in .24s ease;
}

.app-drawer-modal__header,
.app-drawer-modal__footer {
    flex-shrink: 0;
    padding: 1.25rem 1.5rem;
    background: #fff;
}

.app-drawer-modal__header {
    border-bottom: 1px solid #e5e7eb;
}

.app-drawer-modal__body {
    position: relative;
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 1.5rem;
    background: #fff;
}

.app-drawer-modal__footer {
    border-top: 1px solid #e5e7eb;
}

@keyframes app-drawer-modal-slide-in {
    from {
        opacity: 0;
        transform: translateX(24px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@media (max-width: 767.98px) {
    .app-drawer-modal__header,
    .app-drawer-modal__body,
    .app-drawer-modal__footer {
        padding: 1rem;
    }
}
</style>
